<template>
  <div class="img-error-container">
    <div v-if="error" class="err-msg">
      <h3>OOPS! Something went wrong.</h3>
      <h3>Please check back shortly.</h3>
    </div>

    <!--   Images Grid Placeholder   -->
    <div class="ctpx-pdp-images ctpx-pdp-images-a">
      <div class="square-container row mobile-hidden">
        <div class="square">
          <div class="content"></div>
        </div>
        <div class="square">
          <div class="content spread"></div>
        </div>
      </div>
      <div class="square-container row mobile-hidden">
        <div class="square">
          <div class="content"></div>
        </div>
        <div class="square">
          <div class="content"></div>
        </div>
      </div>
    </div>

    <div class="ctpx-pdp-details ctpx-pdp-details-a">
      <!--   Detail Box Placeholder   -->
      <div class="detail-box">
        <div class="row">
          <div class="col">
            <!--   Mini Review Stars Placeholder   -->
            <div class="reviews"></div>
          </div>
          <!-- .col -->
        </div>
        <!-- .row -->

        <!--   Product Title   -->
        <div class="row">
          <div class="col"></div>
        </div>
        <div class="row">
          <div class="col">
            <p class="lead"></p>
          </div>
        </div>
      </div>

      <!--   Variant Color Box Placeholder   -->
      <div class="variant-box colors"></div>

      <!--   Variant Size Box Placeholder   -->
      <div class="variant-box size"></div>

      <!--   Add to Cart Box Placeholder  -->
      <div class="add-to-cart-box"></div>
    </div>
    <!-- ctpx-pdp-details -->
  </div>
</template>

<script src="./ctrl-pdp-err">
// export default {
//     name: 'pdpError'
// }
</script>
